import { render } from "./BillsReceipted.vue?vue&type=template&id=d11b134e&scoped=true"
import script from "./BillsReceipted.vue?vue&type=script&lang=js"
export * from "./BillsReceipted.vue?vue&type=script&lang=js"

import "./BillsReceipted.vue?vue&type=style&index=0&id=d11b134e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d11b134e"]])

export default __exports__